/**
 * Баланс текущего режима: бета (`mode: "beta"`) — данные беты, иначе обычный `balanceV1`. Режим задаётся при старте
 * (`app/mode.ts`), поэтому читать баланс надо в момент использования, а не на уровне модуля.
 */
import type { BalanceData } from "@newfungame/contracts";
import { balanceV1, getBetaBalance } from "@newfungame/engine";
import { getGameMode } from "./mode";

export function activeBalance(): BalanceData {
  return getGameMode() === "beta" ? getBetaBalance() : balanceV1;
}
